// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"4379dd16","732":"d0d1328f","977":"b41675ab"}[chunkId] + ".chunk.js";
};